var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDateIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.458 2.25H15.6247C15.8346 2.25 16.036 2.32902 16.1845 2.46967C16.3329 2.61032 16.4163 2.80109 16.4163 3V15C16.4163 15.1989 16.3329 15.3897 16.1845 15.5303C16.036 15.671 15.8346 15.75 15.6247 15.75H1.37467C1.16471 15.75 0.963348 15.671 0.814882 15.5303C0.666415 15.3897 0.583008 15.1989 0.583008 15V3C0.583008 2.80109 0.666415 2.61032 0.814882 2.46967C0.963348 2.32902 1.16471 2.25 1.37467 2.25H4.54134V0.75H6.12467V2.25H10.8747V0.75H12.458V2.25ZM10.8747 3.75H6.12467V5.25H4.54134V3.75H2.16634V6.75H14.833V3.75H12.458V5.25H10.8747V3.75ZM14.833 8.25H2.16634V14.25H14.833V8.25Z",
    fill: "#4F4F4F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateIcon);
export default __webpack_public_path__ + "static/media/date-icon.fdae4de945fb94ee5821a6c0dcb38e04.svg";
export { ForwardRef as ReactComponent };